export default __webpack_public_path__ + "static/media/img-0363-ovato-nation-full-face.a9014446.png";